import { registerPlugin } from '@capacitor/core';
const CapacitorNfc = registerPlugin('CapacitorNfc', {
    web: () => import('./web').then((m) => new m.CapacitorNfcWeb()),
});
export * from './definitions';
export { CapacitorNfc };
//# sourceMappingURL=index.js.map